
$(document).ready(function () {
    loadedWidget = false;
    expandOneTime = false;

    function disableButton() {
        const $form = $('.product-single__form');
        const $btn  = $form.find('.btn--add-to-cart');
      
        // 1) Read your force-out-of-stock metafield exposed as data-attribute
        const forceOOS = $btn.data('force-oos') === true || $btn.data('force-oos') === 'true';
        if (forceOOS) {
          $btn.prop('disabled', true);
          $btn.find('#subscription-btn').text('Sold out');
          return;
        }
      
        // 2) Fallback to your existing availability logic
        const variantId       = $form.find('[name="id"]').val();
        const vairnatAvailable = $form
          .find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`)
          .data('available');
      
        if (vairnatAvailable) {
          $btn.prop('disabled', true);
          $btn.find('#subscription-btn').text('SOLD OUT');
        } else {
          $btn.prop('disabled', false);
          const rcRadio = $form.find('.jc-custom-rc-radio__input:checked').val();
          if (rcRadio === 'subsave') {
            $btn.find('#subscription-btn').text('Add Subscription to Cart');
          } else {
            $btn.find('#subscription-btn').text('Add to Cart');
          }
        }
      }
      
    /*
    function disableButton() {
        const variantId = $('.product-single__form').find('[name="id"]').val();
        const vairnatAvailable = $('.product-single__form').find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`).data('available');
        const btn = $('.product-single__form').find('.btn--add-to-cart');
        if (vairnatAvailable) {
            btn.prop('disabled', true);
            btn.find('#subscription-btn').text('SOLD OUT');
        } else {
            btn.prop('disabled', false);
            const rcRadio = $('.product-single__form').find('.jc-custom-rc-radio__input:checked');
           
            if (rcRadio.val() == 'subsave') {
                btn.find('#subscription-btn').text('Add Subscription to Cart');
            } else {
                btn.find('#subscription-btn').text('Add to Cart');
            }
        }
    }
    */


    function changePack() {
        const pack = $('.jc-custom-rc-radio__input:checked')
            .next()
            .find('.jc-custom-rc-radio__pack-item.active')
            .data('pack');
    
        $('.jc-js-quantity-selector').val(pack);

        disableButton();
    }
    function changePlan() {
        const plan = $('.jc-custom-rc-radio__plan-item.active').data('plan');
       
        $(`.rc_widget__option__plans__dropdown>option:eq(${plan})`).prop('selected', true);

        disableButton();
    }
    function formatPrice(p) {
        p = Number(String(p).replace('$', ''));
        let price = p.toFixed(2);
        return String(price).replace('.00', '');
    }
    function updateSubscriptionPrices() {
        const subSaveActivePack = $('.jc-custom-subsave .jc-custom-rc-radio__pack-item.active');
        const subSaveComparePrice = subSaveActivePack.find('.jc-custom-rc__compare-price').text().trim();
        const subSaveSalePrice = subSaveActivePack.find('.jc-custom-rc__sale-price').text().trim();

        if (subSaveActivePack.length > 0) {
            $('.jc-custom-subsave .jc-custom-rc__price-box .jc-custom-rc__compare-price')
                .text(`$${formatPrice(subSaveComparePrice)}`);
            $('.jc-custom-subsave .jc-custom-rc__sale-price')
                .first()
                .text(`$${formatPrice(subSaveSalePrice)}`);
        }
    }
    function updateOneTimePrices() {

        // Get the currently active pack in the One-Time Purchase section
        let oneTimeActivePack = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item.active');

        if (oneTimeActivePack.length > 0) {
            // Get data for the active pack
            if (!loadedWidget || !expandOneTime) oneTimeActivePack = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item[data-pack="1"]');
            const oneTimeComparePrice = oneTimeActivePack
                .find('.jc-custom-rc__compare-price')
                .text()
                .trim();
            const oneTimeSalePrice = oneTimeActivePack
                .find('.jc-custom-rc__sale-price')
                .text()
                .trim();
            const packDiscountText = oneTimeActivePack
                .find('.jc-custom-rc__save-price')
                .text()
                .trim();

            // Update the main price box with compare and sale prices
            if (oneTimeComparePrice == 0) {
                $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price').html(
                    `<span class="compare-price"></span> <span class="sale-price">$${formatPrice(oneTimeSalePrice)}</span>`
                );
            } else {
                $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price').html(
                    `<span class="compare-price">$${formatPrice(oneTimeComparePrice)}</span> <span class="sale-price">$${formatPrice(oneTimeSalePrice)}</span>`
                );
            }

            const variantId      = $('[name="id"]').val();
            const variantDiscVal = parseInt(
              $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount') || 0,
              10
            );
          
            // If the variant has its own discount, skip pill-text updates (but we already did prices)
            if (variantDiscVal > 0) {
              return;
            }

            // Update the discount message in the main price box
            const discountElement = $('.jc-custom-onetime .jc-custom-rc__save-price.main');
            discountElement.text(packDiscountText || 'No Discount');

            // Add or remove the "no-discount" class based on the discount text
            if (packDiscountText === 'No Discount') {
                discountElement.addClass('no-discount');
            } else {
                discountElement.removeClass('no-discount');
            }
        } else {
            // Fallback: if no active pack is selected
            const discountElement = $('.jc-custom-onetime .jc-custom-rc__save-price.main');
            $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price').html('');
            discountElement.text('No Discount').addClass('no-discount');
        }
    }

    /*
    const $subPill = $('.jc-custom-subsave .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origSubText = $subPill.data('default-text');
    const $oneTimePill = $('.jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origOneTimeText = "No Discount";
    */
    const $subPill     = $('.jc-custom-subsave .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origSubText  = $subPill.text().trim();
    
    /*
    const $oneTimePill    = $('.jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origOneTimeText = $oneTimePill.text().trim();
    */
    const $oneTimePill = $('.jc-custom-onetime .jc-custom-rc-radio__price .jc-custom-rc__save-price');
    const origOneTimeText = "No Discount";
    

    function changeVariant() {



        const variantId   = $('[name="id"]').val();
        const $discEl     = $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`);
        const discountVal = parseInt($discEl.data('discount') || 0, 10);
        const hasDiscount = discountVal > 0;
        var price = Number($('[data-price-onetime]').text().trim().replace('$', ''));
        const customDiscount = 1 - Number($(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount')) / 100;

        const $subSaleEls = $('.jc-custom-subsave .jc-custom-rc__sale-price');
        const $oneTimeSaleEls = $('.jc-custom-onetime .jc-custom-rc__sale-price');


        const rawNote   = window.variantPillPriceNotes[variantId] || '';

        // log it so you can see exactly what came through
        console.log('variant', variantId, '→', rawNote);
        
        $subSaleEls
            .toggleClass('red',      hasDiscount)
            .toggleClass('standard', !hasDiscount);
        $oneTimeSaleEls
            .toggleClass('red',      hasDiscount)
            .toggleClass('standard', !hasDiscount);

            /*
            if (hasDiscount) {
                $subPill
                  .addClass('discount')
                  .text(`Save ~${discountVal}%`);
            
                $oneTimePill
                  .addClass('discount')
                  .removeClass('no-discount')
                  .text(`Save ${discountVal}%`);
              } else {
                $subPill
                  .removeClass('discount')
                  .text(origSubText);
            
                $oneTimePill
                  .removeClass('discount')
                  .addClass('no-discount')
                  .text(origOneTimeText);
              }
              */
               // 1) Subscribe & Save pill
  const subNote = window.variantPillPriceNotes[variantId];
  if (subNote) {
    $subPill
      .text(subNote)
      .removeClass('no-discount')
      .addClass('discount');
  } else {
    $subPill
      .text(origSubText)
      .removeClass('discount no-discount');
  }

  // 2) One-Time Purchase pill
  if (hasDiscount) {
    $oneTimePill
      .addClass('discount')
      .removeClass('no-discount')
      .text(`Save ${discountVal}%`);
  } else {
    $oneTimePill
      .removeClass('discount')
      .addClass('no-discount')
      .text(origOneTimeText);
  }

        if (customDiscount) {
            document.querySelector('.jc-custom-rc-container').classList.remove('no-discount-container');
            $('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price)}`);
            $('[data-pack="2"]')
                .find('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price * 2)}`);
            $('[data-pack="3"]')
                .find('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price * 3)}`);

            if (loadedWidget && expandOneTime) {
                const activePack = $('.jc-custom-onetime').find('.jc-custom-rc-radio__pack-item.active').data('pack');
                $('.jc-custom-onetime')
                    .find('.jc-custom-rc__sale-price')
                    .html(`<span class="compare-price">$${formatPrice(price * activePack)}</span> <span class="sale-price">$${formatPrice(price * activePack * customDiscount)}</span>`);
            } else {
                $('.jc-custom-onetime')
                    .find('.jc-custom-rc__sale-price')
                    .html(`<span class="compare-price">$${formatPrice(price)}</span> <span class="sale-price">$${formatPrice(price * customDiscount)}</span>`);
            }
            $('.jc-custom-onetime')
                .find('[data-pack="1"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * customDiscount)}`);
            $('.jc-custom-onetime')
                .find('[data-pack="2"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 2 * customDiscount)}`);
            $('.jc-custom-onetime')
                .find('[data-pack="3"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 3 * customDiscount)}`);

            $('.jc-custom-subsave')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 0.8 * customDiscount)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="1"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 0.8 * customDiscount)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="2"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 2 * 0.8 * customDiscount)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="3"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 3 * 0.8 * customDiscount)}`);
        } else {
            document.querySelector('.jc-custom-rc-container').classList.add('no-discount-container');
            $('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price)}`);
            $('[data-pack="2"]')
                .find('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price * 2)}`);
            $('[data-pack="3"]')
                .find('.jc-custom-rc__compare-price')
                .text(`$${formatPrice(price * 3)}`);

            $('.jc-custom-onetime')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price)}`);
            $('.jc-custom-onetime')
                .find('[data-pack="1"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price)}`);
            $('.jc-custom-onetime')
                .find('[data-pack="2"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 2 * 0.9)}`);
            $('.jc-custom-onetime')
                .find('[data-pack="3"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 3 * 0.85)}`);

            $('.jc-custom-subsave')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 0.8)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="1"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 0.8)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="2"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 2 * 0.8)}`);
            $('.jc-custom-subsave')
                .find('[data-pack="3"]')
                .find('.jc-custom-rc__sale-price')
                .text(`$${formatPrice(price * 3 * 0.8)}`);
        }
        const activePack = $('.jc-custom-rc-radio__pack-item.active').data('pack');
        updatePackPrices(activePack);
        disableButton();
     
        
        showDiscountBadgeIfAny();
        

    }
    function updatePackPrices(activePack) {
        if (activePack) {
            // Update based on the current active pack
            if ($('.jc-custom-rc-radio__input:checked').val() == 'subsave') {
                updateSubscriptionPrices();
            } else {
                updateOneTimePrices();
            }
        }
    }
    const location_search = window.location.search;
    var searchInterval = setInterval(searchElement, 100); // short interval

    function stopSearch() {
        clearInterval(searchInterval);
    }

    function searchElement() {
        if ($('[data-widget-container-wrapper]').length > 0) {
            updatePrices();
            setTimeout(function () {
                const location_search = window.location.search;

                if (location_search.indexOf('?variant=') === -1) {
                    const $radio = $('.single-option-selector__radio[value="2500mg"]');
                    if ($radio.length) {
                      // 1) check it
                      $radio.prop('checked', true);
                      // 2) fire your change listener
                      $radio.trigger('change');
                      // 3) explicitly run your price-update routine
                      changeVariant();
                    } else {
                      const $alt = $('.jc-input-index-2[name="potency"]');
                      $alt.prop('checked', true).trigger('change');
                      changeVariant();
                    }
                  }

                // Hide spinner and show widget
                $('.jc-custom-rc-loading').hide();
                $('.jc-custom-rc-container').fadeIn(200);
                loadedWidget = true;
                
                changeVariant();

                stopSearch();
            }, 100);
        }
    }

    /*
    function showDiscountBadgeIfAny() {
        
        // how many badges are we about to clear?
        const removed = document.querySelectorAll('.discount-tab.pdp').length;
        
        // now clear them
        document.querySelectorAll('.discount-tab.pdp').forEach(el => el.remove());
        
        // read the current variant’s discount
        const variantId   = $('[name="id"]').val();
        const discountVal = parseInt(
          $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount') || 0,
          10
        );
        if (discountVal <= 0) {
          return;
        }
      
        // append the badge
        const $firstPane = $('.tabs-content-product .w-tab-pane.w--tab-active').first();
        if ($firstPane.length) {
          const badge = $(`
            <div class="discount-tab pdp">
              <span class="discount-text">save</span>
              <span class="discount-text bigger">${discountVal}%</span>
            </div>
          `);
          $firstPane.append(badge);
        }
      }

      $('.tabs-content-product .w-tab-pane').each(function() {
        const pane = this;
        const obs = new MutationObserver(muts => {
          muts.forEach(m => {
            if (m.attributeName === 'class' &&
                pane.classList.contains('w--tab-active')) {
              showDiscountBadgeIfAny();
            }
          });
        });
        obs.observe(pane, { attributes: true, attributeFilter: ['class'] });
      });
      */
     // 1) Show/hide badge only on matching pane
function showDiscountBadgeIfAny() {
    // 1a) clear existing badges
    $('.discount-tab.pdp').remove();
  
    // 1b) read current variant & its discount
    const variantId = $('[name="id"]').val();
    const $discEl   = $(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`);
    const discountVal = parseInt($discEl.data('discount') || 0, 10);
    if (discountVal <= 0) return;
  
    // 1c) read which image this variant “owns”
    const variantImageId = parseInt($discEl.data('image-id') || 0, 10);
  
    // 1d) read the active pane’s image id
    const $activePane = $('.tabs-content-product .w-tab-pane.w--tab-active');
    const paneImageId = parseInt($activePane.data('image-id') || 0, 10);
  
    // 1e) only badge if they match
    if (variantImageId !== paneImageId) return;
  
    // 1f) append the badge
    const $badge = $(`
      <div class="discount-tab pdp">
        <span class="discount-text">save</span>
        <span class="discount-text bigger">${discountVal}%</span>
      </div>
    `);
    $activePane.append($badge);
  }
  
  // 2) re-run on tab-pane activation
  $('.tabs-content-product .w-tab-pane').each(function() {
    const pane = this;
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === 'class' && pane.classList.contains('w--tab-active')) {
          showDiscountBadgeIfAny();
        }
      });
    });
    obs.observe(pane, { attributes: true, attributeFilter: ['class'] });
  });
  
  // 3) re-run on variant change
  $('.single-option-selector__radio, .product-single__variants').on('change', showDiscountBadgeIfAny);
  
  // 4) initial pass
  $(document).ready(showDiscountBadgeIfAny);
  
      
      

    function updatePromoDisclaimer() {
        // Get the currently selected variant's ID
        const selectedVariantId = $('.product-single__variants').val();
        $('.promo-pdp-disclaimer').addClass('hidden');
        if (!selectedVariantId) return;
        $(`.promo-pdp-disclaimer[data-variant-id="${selectedVariantId}"]`)?.removeClass('hidden');
    }




    $(document).on('change', '.jc-product-page-form-wrapper .single-option-selector__radio', function () {
        changeVariant();
    });

    $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-rc-radio__pack-item', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).closest('.jc-custom-rc-radio').hasClass('jc-custom-subsave')) {
            $(this).closest('.jc-custom-rc-radio__packs')
                .find('.jc-custom-rc-radio__pack-item')
                .removeClass('active');
            $(this).addClass('active');
            changePack();
            updateSubscriptionPrices();
        } else if ($(this).closest('.jc-custom-rc-radio').hasClass('jc-custom-onetime')) {
            $(this).closest('.jc-custom-rc-radio__packs')
                .find('.jc-custom-rc-radio__pack-item')
                .removeClass('active');
            $(this).addClass('active');
            changePack();
            updateOneTimePrices();
        }
    });

    $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-ra-radio-wrapper', function (e) {
        updateSubscriptionPrices();
        updateOneTimePrices();
    });

    $(document).on('change', '.jc-product-page-form-wrapper .jc-custom-rc-radio__input', function () {
        expandOneTime = true;
        if ($('.jc-custom-rc-radio__input:checked').val() == 'subsave') {
            $('.rc-radio__input[value="subsave"]').click();
            $('#subscription-btn').text('Add Subscription to Cart');
            if ($(window).width() < 768) {
                $('#disclaimer-text').html('60-Day Money-Back Guarantee<br> Free U.S. Shipping');
            } else {
                $('#disclaimer-text').text('60-Day Money-Back Guarantee | Free U.S. Shipping');
            }
        } else {
            $('.rc-radio__input[value="onetime"]').click();
            $('#subscription-btn').text('Add to Cart');
            $('#disclaimer-text').text('60-Day Money-Back Guarantee | Free U.S. Shipping Over $60');
            if ($(window).width() < 768) {
                $('#disclaimer-text').html('60-Day Money-Back Guarantee<br>Free U.S. Shipping Over $60');
                $('body, html').scrollTop($('.jc-custom-onetime').position().top + 540);
            } else {
                $('#disclaimer-text').text('60-Day Money-Back Guarantee | Free U.S. Shipping Over $60');
            }
        }
        changePack();
        if ($('.jc-custom-rc-radio__input:checked').val() == 'subsave') {
            updateSubscriptionPrices();
        } else {
            updateOneTimePrices();
        }
        if ($(this).closest('.jc-custom-rc-container').find('.btn--add-to-cart').prop('disabled')) {
            $(this).closest('.jc-custom-rc-container').find('.btn--add-to-cart').find('#subscription-btn').text('Sold out');
        }
    });

    // Event listener for plan items
    $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-rc-radio__plan-item', function () {
        $('.jc-custom-rc-radio__plan-item').removeClass('active');
        $(this).addClass('active');
        changePlan();
    });


    // Update the disclaimer when the variant changes
    $(document).on('change', '.jc-product-page-form-wrapper .single-option-selector__radio', function () {
        updatePromoDisclaimer();
    });

    // Ensure disclaimer is set correctly on initial page load
    $(document).ready(function () {
        updatePromoDisclaimer();
    });



    // Hard timeout: stop spinner after 60s (fallback)
    setTimeout(function () {
        stopSearch();
        $('.jc-custom-rc-loading').hide();
        $('.jc-custom-rc-container').fadeIn(200);
    }, 60000);

    function updatePrices() {
        document.querySelectorAll('.jc-custom-rc__compare-price').forEach(priceElement => {
            const price = formatPrice(priceElement.textContent.trim());
            priceElement.textContent = `$${price}`;
        });

        document.querySelectorAll('.jc-custom-rc__sale-price').forEach(priceElement => {
            if (priceElement.querySelector('.compare-price')) {
                const compareAtPrice = formatPrice(priceElement.querySelector('.compare-price').textContent.trim());
                priceElement.querySelector('.compare-price').textContent = `$${compareAtPrice}`;

                const salePrice = formatPrice(priceElement.querySelector('.sale-price').textContent.trim());
                priceElement.querySelector('.sale-price').textContent = `$${salePrice}`;
            } else {
                const price = formatPrice(priceElement.textContent.trim());
                priceElement.textContent = `$${price}`;
            }
        });
    }

});


